import React from "react";
const NftActivity = () => {
    return (
        <div className="_activity_wrapper">
            <div className="_activity_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="_activity_border_wrap">
                                <div className="_activity_border_heading_wrap">
                                    <div className="_activity_border_heading_txt">
                                        <p className="_activity_border_heading">Item activity</p>
                                    </div>
                                    <div className="_activity_border_heading_btns">
                                        <div className="_activity_border_heading_btn01">
                                            <button type="button" className="_activity_border_heading_btn">Listings</button>
                                        </div>
                                        <div className="_activity_border_heading_btns">
                                            <button type="button" className="_activity_border_heading_btn">Sales</button>
                                        </div>
                                        <div className="_activity_border_heading_btns">
                                            <button type="button" className="_activity_border_heading_btn">Bids</button>
                                        </div>
                                        <div className="_activity_border_heading_btns">
                                            <button type="button" className="_activity_border_heading_btn">Transfers</button>
                                        </div>
                                    </div>
                                </div>

                                <div className="_activity_border_table_wrap">
                                    <table className="table _Offers_border_table">
                                        <thead>
                                            <tr>
                                                <th className="_Offers_border_table_th" scope="col">Event</th>

                                                <th className="_Offers_border_table_th" scope="col">Price</th>
                                                <th className="_Offers_border_table_th" scope="col">From</th>
                                                <th className="_Offers_border_table_th" scope="col">To</th>
                                                <th className="_Offers_border_table_th" scope="col">Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td className="_Offers_border_table_td _font_width">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13"
                                                        fill="none" viewBox="0 0 16 13">
                                                        <path fill="#000"
                                                            d="M15.488 3.674 12.5.651V2.9H1.25v1.512H12.5v2.25l2.988-2.989ZM.512 9.651 3.5 12.674v-2.25h11.25V8.913H3.5v-2.25L.512 9.65Z" />
                                                    </svg>
                                                    Transfer
                                                </td>
                                                <td className="_Offers_border_table_td"></td>
                                                <td className="_Offers_border_table_td">nftinitcom</td>
                                                <td className="_Offers_border_table_td">nonkosi.joyi</td>
                                                <td className="_Offers_border_table_td">31 Dec 2021</td>
                                            </tr>

                                            <tr>
                                                <td className="_Offers_border_table_td _font_width">
                                                    Sale
                                                </td>
                                                <td className="_Offers_border_table_td">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24"
                                                        fill="none" viewBox="0 0 16 24">
                                                        <path fill="#6B8CEF" fill-rule="evenodd"
                                                            d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                    2.52 ETH
                                                </td>
                                                <td className="_Offers_border_table_td">nonkosi.joyi</td>
                                                <td className="_Offers_border_table_td">peter.tay</td>
                                                <td className="_Offers_border_table_td">13 Jan 2022</td>
                                            </tr>

                                            <tr>
                                                <td className="_Offers_border_table_td _font_width">
                                                    Sale
                                                </td>
                                                <td className="_Offers_border_table_td">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24"
                                                        fill="none" viewBox="0 0 16 24">
                                                        <path fill="#6B8CEF" fill-rule="evenodd"
                                                            d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                    3.65 ETH
                                                </td>
                                                <td className="_Offers_border_table_td">peter.tay</td>
                                                <td className="_Offers_border_table_td">jumaima</td>
                                                <td className="_Offers_border_table_td">19 Jan 2022</td>
                                            </tr>

                                            <tr>
                                                <td className="_Offers_border_table_td _font_width">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="13"
                                                        fill="none" viewBox="0 0 16 13">
                                                        <path fill="#000"
                                                            d="M15.488 3.674 12.5.651V2.9H1.25v1.512H12.5v2.25l2.988-2.989ZM.512 9.651 3.5 12.674v-2.25h11.25V8.913H3.5v-2.25L.512 9.65Z" />
                                                    </svg>
                                                    Transfer
                                                </td>
                                                <td className="_Offers_border_table_td"></td>
                                                <td className="_Offers_border_table_td">jumaima</td>
                                                <td className="_Offers_border_table_td">faadi.al.rahman</td>
                                                <td className="_Offers_border_table_td">4 Feb 2022</td>
                                            </tr>

                                            <tr>
                                                <td className="_Offers_border_table_td _font_width">
                                                    Sale
                                                </td>
                                                <td className="_Offers_border_table_td">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24"
                                                        fill="none" viewBox="0 0 16 24">
                                                        <path fill="#6B8CEF" fill-rule="evenodd"
                                                            d="M7.988.74v8.558l-6.332 2.83L7.988 9.3v7.43l-7.233-4.2L7.988.74Zm.002 0 7.234 11.79-7.234 4.2V9.3l6.333 2.828-6.333-2.83V.74Zm-.002 17.336v5.815L.75 13.877l7.238 4.2Zm.002 5.815v-5.816l7.234-4.198L7.99 23.891Z"
                                                            clip-rule="evenodd" />
                                                    </svg>
                                                    4.23 ETH
                                                </td>
                                                <td className="_Offers_border_table_td">faadi.al.rahman</td>
                                                <td className="_Offers_border_table_td">thanawan</td>
                                                <td className="_Offers_border_table_td">21 Feb 2022</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default NftActivity;